import { SexualOrientation } from '@/types';

export enum GA_EVENT_NAMES {
    GENERIC = 'GA4 - Generic Event',

    // General
    GEO = 'geo',
    SIGNUP = 'signup',
    LOGIN = 'login',
    CLICK_LAYOUT_CHANGE_ICON = 'click_layout_change_icon',

    // Age Verification
    AGE_VERIFICATION_COMPLETED = 'age_verification_completed',

    // Search
    SEARCH = 'search',
    SEARCH_SUGGESTION_SELECTED = 'search_suggestion_selected',
    SEARCH_TO_VIDEO_CLICK = 'search_to_video_click',

    // Gif
    GIF_SUBSCRIBE_CLICK = 'gif_subscribe_click',
    GIF_UNSUBSCRIBE_CLICK = 'gif_unsubscribe_click',
    GIF_JOIN_NOW_CLICK = 'gif_join_now_click',

    // Channel
    CHANNEL_SUBSCRIBE_CLICK = 'channel_subscribe_click',
    CHANNEL_UNSUBSCRIBE_CLICK = 'channel_unsubscribe_click',
    CHANNEL_JOIN_NOW_CLICK = 'channel_join_now_click',

    // Photo
    PHOTO_SUBSCRIBE_CLICK = 'ai_creator_subscribe_click',
    PHOTO_UNSUBSCRIBE_CLICK = 'ai_creator_unsubscribe_click',
    PHOTO_CHAT_CLICK = 'ai_creator_chat_click',

    // Experiment view
    EXPERIMENT_VIEW = 'experiment_view',

    // Affiliate link tracking
    AFF_JOIN_NOW_CLICK = 'aff_join_now_click',

    // Video page related clicks (A/B test)
    VIDEO_PAGE_RELATED_VIDEO_CLICK = 'video_page_related_video_click',
    VIDEO_PAGE_RELATED_PLAYLIST_CLICK = 'video_page_related_playlist_click',
}

export type GifGAEvent =
    | GA_EVENT_NAMES.GIF_SUBSCRIBE_CLICK
    | GA_EVENT_NAMES.GIF_UNSUBSCRIBE_CLICK
    | GA_EVENT_NAMES.GIF_JOIN_NOW_CLICK;

export type PhotoGAEvent =
    | GA_EVENT_NAMES.PHOTO_SUBSCRIBE_CLICK
    | GA_EVENT_NAMES.PHOTO_UNSUBSCRIBE_CLICK
    | GA_EVENT_NAMES.PHOTO_CHAT_CLICK;

export type SearchSuggestionType =
    | 'recent_search'
    | 'trending_searches'
    | 'trending_models'
    | 'keyword'
    | 'channel'
    | 'model';

export type GAEvent = Record<string, string>;

export type GTag = (command: string, action: string, params: Record<string, any>) => void;

export type TrackingIdEvents = 'signup' | 'login';

export type SignupType = 'regular' | 'social';

export type ChannelGAEvent = GA_EVENT_NAMES.CHANNEL_SUBSCRIBE_CLICK | GA_EVENT_NAMES.CHANNEL_UNSUBSCRIBE_CLICK;

export type SendVideoClickParams = {
    videoId: number;
    pageNumber: number;
    itemPosition: number;
    keyword?: string;
    countryCode?: string;
    orientation?: SexualOrientation;
    loggedIn?: boolean;
};

export type VideoPageRelatedVideoClickParams = {
    sourceId: number;
    targetId: number;
    list: 'sidebar' | 'below_video';
    position: number;
    variationId: number;
};

export type VideoPageRelatedPlaylistClickParams = {
    sourceId: number;
    targetId: number;
    position: number;
    variationId: number;
};
